<home-navbar theme="light"></home-navbar>

<header class="header text-white bg-dark pt-9 pb-5" style="background-image: linear-gradient(-20deg, #2b5876 0%, #4e4376 100%);">
  <div class="container">
    <h3>{{ title }}</h3>
  </div>
</header>
